module.exports = __webpack_public_path__ + "img/宁晋电缆.2dc63df5.jpg";